import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App';
import {
    AlertContextProvider,
    DialogContextProvider,
    LoaderContextProvider,
    ProfileContextProvider
} from './contexts';

const rootElement = document.getElementById('root')!;
const root = createRoot(rootElement);

root.render(
    <LoaderContextProvider>
        <AlertContextProvider>
            <DialogContextProvider>
                <BrowserRouter>
                    <ProfileContextProvider>
                        <App />
                    </ProfileContextProvider>
                </BrowserRouter>
            </DialogContextProvider>
        </AlertContextProvider>
    </LoaderContextProvider>
);
